import {Injectable} from '@angular/core';
import {UserInfoDTO} from '@rsp/models/dto/user-info.dto';
import {RspEndpointsService} from '@rsp/shared/services/rest/rsp-endpoints.service';
import {AccessRoles} from '@rsp/models/enum/access-roles.enum';


@Injectable({providedIn: 'root'})
export class UserService {
  private userInfo: UserInfoDTO;

  constructor(private rspEndpoints: RspEndpointsService) {

  }

  public init(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.rspEndpoints.getUserInfo().subscribe((res) => {
        this.userInfo = res.result;
        resolve(true);
      }, (err) => {
        resolve(false);
      });
    });

  }


  public isAuth(): boolean {
    return !!this.userInfo;
  }

  public getFullname(): string {
    return this.isAuth() ? this.userInfo.displayName : undefined;
  }

  public hasRole(requiredRole: AccessRoles): boolean {
    return this.isAuth() && this.userInfo.roles.reduce( (acc: boolean, cur) => {
      if (cur === requiredRole) {
        acc = true;
      }
      return acc;
    }, false);
  }


}
